import { useState, useEffect } from 'react';
import { VideoElement } from '../../types/player';
import { getSavedVolume, saveVolume } from '../../utils/storage-utils';

export const useVolumeControl = (videoElement: VideoElement) => {
  const [volume, setVolume] = useState(() => getSavedVolume());
  const [lastVolume, setLastVolume] = useState(1);
  const [isMuted, setIsMuted] = useState(false);

  // Apply volume when video element changes
  useEffect(() => {
    if (videoElement && volume !== undefined) {
      videoElement.volume = volume;
      videoElement.muted = volume === 0;
      setIsMuted(volume === 0);
    }
  }, [videoElement, volume]);

  // Handle volume change
  const handleVolumeChange = (newVolume: number) => {
    if (!videoElement) return;

    videoElement.volume = newVolume;
    setVolume(newVolume);
    saveVolume(newVolume);

    if (newVolume > 0) {
      setLastVolume(newVolume);
      setIsMuted(false);
      videoElement.muted = false;
    } else {
      setIsMuted(true);
      videoElement.muted = true;
    }
  };

  // Toggle mute
  const toggleMute = () => {
    if (!videoElement) return;

    if (isMuted) {
      videoElement.muted = false;
      setIsMuted(false);
      handleVolumeChange(lastVolume);
    } else {
      videoElement.muted = true;
      setIsMuted(true);
      setLastVolume(volume);
      handleVolumeChange(0);
    }
  };

  return {
    volume,
    isMuted,
    handleVolumeChange,
    toggleMute,
  };
};
